module.exports = __webpack_public_path__ + "img/like.471eb4dc.svg";